import {get} from "../../utils/api";

export const getStatsItems = async (from, to, page, pageSize) => {
    console.log(from, to, page, pageSize);
    const {
        data: { data },
    } = await get(`pos/v1/accounting/stats/${from}/${to}?page=${page}&pageSize=${pageSize}`);
    return data;
};
